import { ProductUnit } from "../../../types/product.type";

/** A unit with a name, the only kind that can label a product. */
type NamedProductUnit = ProductUnit & { unit: string };

const isNamedUnit = (entry: ProductUnit): entry is NamedProductUnit =>
  typeof entry.unit === "string" && entry.unit !== "";

/** A unit without a sequence sorts after every unit that has one. */
const sequenceOf = (entry: ProductUnit): number =>
  entry.sequence ?? Number.POSITIVE_INFINITY;

/**
 * The unit a product is counted in: the one marked default, else the one with the lowest
 * sequence, else null. Head office's cost list resolves the unit the same way, so the two
 * screens always name the same unit.
 */
export const resolveProductUnit = (
  units: ProductUnit[] | null,
): string | null => {
  // `units_json` is free-form JSON from the vansale feed, so its shape is checked here.
  if (!Array.isArray(units)) return null;

  const namedUnits = units.filter(isNamedUnit);
  const defaultUnit = namedUnits.find((entry) => entry.isdefault === true);
  if (defaultUnit) return defaultUnit.unit;

  const lowestSequenceUnit = namedUnits.reduce<NamedProductUnit | null>(
    (lowest, entry) =>
      lowest === null || sequenceOf(entry) < sequenceOf(lowest)
        ? entry
        : lowest,
    null,
  );
  return lowestSequenceUnit?.unit ?? null;
};
